import { get } from "lodash";
import { useSelector } from "react-redux";

import {
  REQUEST_MASTER_RESTAURANT,
  REQUEST_CREATE_MASTER_RESTAURANT,
  SET_MASTER_RESTAURANT,
  SUCCESS_CREATE_MASTER_RESTAURANT,
  ERROR_GET_MASTER_RESTAURANT,
  ERROR_CREATE_MASTER_RESTAURANT,
  SET_MESSAGE_MASTER_RESTAURANT,
  SUCCESS_DELETE_MASTER_RESTAURANT,
  SUCCESS_UPDATE_MASTER_RESTAURANT,
  REQUEST_DELETE_MASTER_RESTAURANT,
  REQUEST_UPDATE_MASTER_RESTAURANT,
  ERROR_DELETE_MASTER_RESTAURANT,
  ERROR_UPDATE_MASTER_RESTAURANT,
} from "./restaurantActionTypes";

interface IState {
  busy: boolean;
  message: string;
  masterRestaurant: any[];
}

const initialState: IState = {
  busy: false,
  message: "",
  masterRestaurant: [],
};

const restaurant = (state = initialState, action: Record<string, any>) => {
  switch (action.type) {
    case REQUEST_MASTER_RESTAURANT:
    case REQUEST_CREATE_MASTER_RESTAURANT:
    case REQUEST_DELETE_MASTER_RESTAURANT:
    case REQUEST_UPDATE_MASTER_RESTAURANT:
      return {
        ...state,
        busy: true,
        message: "",
      };

    case SET_MESSAGE_MASTER_RESTAURANT:
      return {
        ...state,
        message: "",
      };

    case SET_MASTER_RESTAURANT:
      return {
        ...state,
        busy: false,
        message: "",
        masterRestaurant: action.payload,
      };

    case SUCCESS_CREATE_MASTER_RESTAURANT:
      // console.log(action.payload);
      return {
        ...state,
        busy: false,
        message: "",
        masterRestaurant: [...state.masterRestaurant, action.payload],
      };
    case SUCCESS_DELETE_MASTER_RESTAURANT:
      return {
        ...state,
        busy: false,
        message: "",
        masterRestaurant: state.masterRestaurant.filter(
          (tutorial) => get(tutorial, "_id") !== action.payload
        ),
      };

    case SUCCESS_UPDATE_MASTER_RESTAURANT:
      return {
        ...state,
        busy: false,
        message: "",
        masterRestaurant: state.masterRestaurant.map((mp) => {
          return get(mp, "_id") === action.payload._id ? action.payload : mp;
        }),
      };

    case ERROR_GET_MASTER_RESTAURANT:
    case ERROR_CREATE_MASTER_RESTAURANT:
    case ERROR_UPDATE_MASTER_RESTAURANT:
    case ERROR_DELETE_MASTER_RESTAURANT:
      return {
        ...state,
        busy: false,
        message:
          action.payload || "Something happened wrong try again after sometime",
      };
    default:
      return state;
  }
};

export default restaurant;

export function useRestaurantMaster() {
  return useSelector((state: Record<string, any>) => state.restaurant);
}
